import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";

import { fetchMe } from "../api/users";
import { setUser } from "../api/redux-toolkit/reducer/authSlice";
import { useAppDispatch } from "../stores/hooks";
import { ME_QUERY_KEY } from "./useMe";

/**
 * Reload `GET /v1/users/me` and push the fresh user into both the Redux auth
 * slice (so the NavBar avatar/name update) and the `useMe` query cache. Call
 * after a successful self-service profile edit.
 */
export function useRefreshProfile() {
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();

  return useCallback(async () => {
    const me = await fetchMe();
    dispatch(setUser(me.user));
    queryClient.setQueryData(ME_QUERY_KEY, me);
    return me;
  }, [dispatch, queryClient]);
}
